import { default as createSerializerCache } from "@emotion/cache";

/** Cache for serialized class names
 * See https://emotion.sh/docs/@emotion/cache */
export const serializerCache = createSerializerCache({
  key: "ovrsea",
  prepend: true,
});
